import React from 'react';
import styled from 'styled-components';
import { theme } from '../../theme';
import { Field } from '../form';
import { generateTestId } from '../../utils';

export type RangeInputProps = {
  currentValue: { min?: number; max?: number };
  range: { min?: number; max?: number };
  onMinChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onMaxChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  formatPlaceholder: (value: string | number) => string;
  errorMessage?: string;
  attribute?: string;
};

const InputContainer = styled.div`
  display: flex;
  gap: ${theme.spacings[2].rem};
  align-items: center;
  padding-bottom: ${theme.spacings[2].rem};
`;

const ErrorMessage = styled.div`
  ${theme.typography.uiText.xs}
  color: ${theme.colors.system.systemRed};
`;

const StyledField = styled(Field)`
  margin-bottom: 0;
  background-color: ${({ theme }) => theme.colors.primary.white};
`;

const Wrapper = styled.div`
  gap: ${theme.spacings[3].rem};
  display: flex;
  flex-direction: column;
`;

export const RangeInput: React.FC<RangeInputProps> = ({
  currentValue,
  range,
  onMinChange,
  onMaxChange,
  errorMessage,
  formatPlaceholder,
  attribute,
}) => {
  return (
    <Wrapper data-testid={generateTestId('range-input', attribute)}>
      <InputContainer>
        <StyledField
          value={currentValue?.min}
          type="number"
          size="sm"
          placeholder={formatPlaceholder(range?.min || 0)}
          hasWrapperMarginBottom={false}
          onChange={onMinChange}
          useParentState
          controlled
          data-testid={generateTestId('min-input', attribute)}
        />
        to
        <StyledField
          value={currentValue?.max}
          type="number"
          size="sm"
          placeholder={formatPlaceholder(range?.max || 5000)}
          hasWrapperMarginBottom={false}
          onChange={onMaxChange}
          useParentState
          controlled
          data-testid={generateTestId('max-input', attribute)}
        />
      </InputContainer>
      {errorMessage !== '' && (
        <ErrorMessage data-testid={generateTestId('error-message', attribute)}>
          {errorMessage}
        </ErrorMessage>
      )}
    </Wrapper>
  );
};
